import { useEffect } from 'react';

import type { VStackProps } from '@rtkwlf/fenrir-react';
import { VStack } from '@rtkwlf/fenrir-react';

import { ErrorBoundary } from '@platform/client/components/error-boundaries/error-boundary';

import { scrollToTop as doScroll } from '@packages/utils/base.utils';

export interface PageWrapperProps extends VStackProps {
  scrollToTop?: boolean;
}

export const PageWrapper = ({
  children,
  scrollToTop = true,
  ...rest
}: PageWrapperProps) => {
  useEffect(() => {
    if (scrollToTop) doScroll();
  }, [scrollToTop]);

  return (
    <ErrorBoundary>
      <VStack
        boxShadow="default"
        borderRadius="default"
        backgroundColor="widgetDefault"
        gap="zero"
        padding="medium"
        {...rest}
      >
        {children}
      </VStack>
    </ErrorBoundary>
  );
};
